module.exports = __webpack_public_path__ + "img/Abgehangen.d6246303.svg";